import React, { Component } from "react";
import { ButtonGroup, Button, Media, Container, Row, Col } from "reactstrap";
import { joinCss } from "../helpers/utils";

import classes from "./DisplayOptionsSection.module.scss";

import ascending from "../images/sortAsc.png";
import ascendingSelected from "../images/sortAscSelected.png";
import descending from "../images/sortDes.png";
import descendingSelected from "../images/sortDesSelected.png";
import cubes from "../images/cubes.png";
import cubesSelected from "../images/cubesSelected.png";
import list from "../images/list.png";
import listSelected from "../images/listSelected.png";

class displayOptionsSection extends Component {
  constructor() {
    super();
    this.state = {
      displayCubeTableOptions: true,
      xsMode: false
    };
  }

  updateDimensions() {
    if (window.innerWidth <= 768 || window.screen.width <= 768) {
      this.setState({ displayCubeTableOptions: false });
      this.props.dispayModeClick(false);
    } else {
      this.setState({ displayCubeTableOptions: true });
    }
    if (window.innerWidth <= 576 || window.screen.width <= 576) {
      this.setState({ xsMode: true });
    } else {
      this.setState({ xsMode: false });
    }
  }

  /**
   * Add event listener
   */
  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }

  /**
   * Remove event listener
   */
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }
  render() {
    let categorySection = "";
    if (this.props.displayOptions.displaySortByCategory) {
      categorySection = (
        <ButtonGroup size="sm" className="float-right pt-4">
          <span className={joinCss(classes.categoryLabel, "pl-3")}>
            {this.props.displayOptions.categoryText}:
          </span>
          <Button
            color="#e9edf4"
            onClick={() => this.props.sortByClick("category")}
            active={this.props.sortBy === "category"}
          >
            מספר פרק
          </Button>
          <Button
            color="#e9edf4"
            onClick={() => this.props.sortByClick("updateDate")}
            active={this.props.sortBy === "updateDate"}
          >
            תאריך עידכון
          </Button>
        </ButtonGroup>
      );
    } else {
      categorySection = (
        <div
          className={joinCss(
            classes.categoryLabel,
            this.state.xsMode ? "pt-4" : "float-right pt-4"
          )}
        >
          {this.props.displayOptions.categoryText}
        </div>
      );
    }
    return (
      <Container className={classes.displayOptionsContainer}>
        <Row className="justify-content-center">
          <Col
            md="12"
            lg="8"
            className={joinCss(classes.displayOptions, "text-center")}
          >
            <Row>
              <Col lg="8" md="7" sm="12">
                {categorySection}
                <ButtonGroup
                  size="sm"
                  className={
                    this.state.xsMode ? "pt-2 mr-2" : "float-right pt-2 mr-2"
                  }
                >
                  <Button
                    color="link"
                    onClick={() => this.props.sortModeClick("descending")}
                    active={this.props.sortMode === "descending"}
                  >
                    <Media
                      className={classes.displayOptionImage}
                      src={
                        this.props.sortMode === "descending"
                          ? descendingSelected
                          : descending
                      }
                      alt="מיון יורד"
                    />
                  </Button>
                  <Button
                    color="link"
                    onClick={() => this.props.sortModeClick("ascending")}
                    active={this.props.sortMode === "ascending"}
                  >
                    <Media
                      className={classes.displayOptionImage}
                      src={
                        this.props.sortMode === "ascending"
                          ? ascendingSelected
                          : ascending
                      }
                      alt="מיון עולה"
                    />
                  </Button>
                </ButtonGroup>
              </Col>
              {this.state.displayCubeTableOptions ? (
                <Col lg="4" md="5">
                  <ButtonGroup className="float-left pt-2" size="sm">
                    <Button
                      color="link"
                      onClick={() => this.props.dispayModeClick(true)}
                      active={this.props.showTable === true}
                    >
                      <Media
                        className={classes.displayOptionImage}
                        src={
                          this.props.showTable === true ? listSelected : list
                        }
                        alt="תצוגת טבלה"
                      />
                    </Button>
                    <Button
                      color="link"
                      onClick={() => this.props.dispayModeClick(false)}
                      active={this.props.showTable === false}
                    >
                      <Media
                        className={classes.displayOptionImage}
                        src={
                          this.props.showTable === false ? cubesSelected : cubes
                        }
                        alt="תצוגת רשימה"
                      />
                    </Button>
                  </ButtonGroup>
                </Col>
              ) : (
                ""
              )}
            </Row>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default displayOptionsSection;
